import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TCITooltip } from '@/components/ui/Tooltip';
import Modal from '../../../common/Modal';
import Form from './Form';
import styles from './index.module.scss';

export default class ShareLink extends Component {
  static propTypes = {
    button: PropTypes.bool,
    iconClasses: PropTypes.string,
    linkClasses: PropTypes.string,
    linkText: PropTypes.string,
    model: PropTypes.string.isRequired,
    replaceOnShare: PropTypes.bool,
    sharable: PropTypes.bool,
    shareQuestionTooltip: PropTypes.bool,
    shared: PropTypes.bool,
    sharedToDistrict: PropTypes.bool,
    withTooltip: PropTypes.bool,
  };

  static defaultProps = {
    button: false,
    iconClasses: null,
    linkClasses: null,
    linkText: null,
    replaceOnShare: false,
    sharable: true,
    shareQuestionTooltip: false,
    shared: false,
    sharedToDistrict: false,
    withTooltip: true,
  };

  constructor(props) {
    super(props);
    this.state = { ...props };
  }

  _openModal(event) {
    event.preventDefault();
    if (this.props.shared) return;
    this.setState({modalIsOpen: true});
  }

  _closeModal() {
    this.setState({modalIsOpen: false});
  }

  _onSuccess(districtOnly) {
    this.setState({shared: true, sharedToDistrict: districtOnly === 'true'});
  }

  _shareButton() {
    return (
      this.props.button ?
      <button
        type="button"
        className={this.props.linkClasses}
        onClick={this._openModal.bind(this)}>
        <i className={`fa fa-share ${this.props.iconClasses}`} aria-hidden="true" /> {this.props.linkText}
      </button> :
        this.state.sharable ?
          <a
            aria-disabled={this.props.shared ? 'true' : undefined}
            className={`${this.props.linkClasses} ${this.props.shared && 'disabled link-disabled'} js-prevent-default`}
            href="#"
            role="button"
            onClick={this.props.shared ? e => e.preventDefault() : this._openModal.bind(this)}>
            <i className={`fa fa-share ${this.props.iconClasses}`} aria-hidden="true" /> {this.props.linkText}
          </a> :
          <a
            aria-disabled="true"
            className={`${this.props.linkClasses} js-prevent-default link-disabled disabled`}
            href="#"
            role="button">
            <i className={`fa fa-share ${this.props.iconClasses}`} aria-hidden="true" /> {this.props.linkText}
          </a>
    )
  }

  _sharedText() {
    return (
      <div className="p5">
        {this.props.replaceOnShare &&
          <span className="shared-question"><i className="fa fa-check mr5" aria-hidden="true" /></span>}
        This {this.props.model.toLowerCase()} is currently shared
        {this.state.sharedToDistrict ? ` within your district only` :
                                       ` with all teachers, including your district`}.
      </div>
    )
  }

  _sharedTooltip() {
    return (
      <TCITooltip>
        <TCITooltip.Trigger asChild>{this._shareButton()}</TCITooltip.Trigger>
        <TCITooltip.Content>{this._sharedText()}</TCITooltip.Content>
      </TCITooltip>
    );
  }

  static _unsharableText() {
    return (
      <div className="p5">
        Tests without questions can’t be shared.
      </div>
    );
  }

  _unsharableTooltip() {
    return (
      <TCITooltip>
        <TCITooltip.Trigger asChild>{this._shareButton()}</TCITooltip.Trigger>
        <TCITooltip.Content>{ShareLink._unsharableText()}</TCITooltip.Content>
      </TCITooltip>
    );
  }

  _shareQuestionTooltip() {
    if (!this.props.shareQuestionTooltip) return null;

    const tooltipMessage = 'Help your fellow teachers by sharing your assessment questions! ' +
      "We'll put your question in the Teacher Question Bank for teachers to add to their own assessments.";

    return (
      <h4 className={styles.shareQuestion}>
        Share Your Creativity
        <TCITooltip>
          <TCITooltip.Trigger asChild>
            <i aria-label={tooltipMessage} className="fa fa-question-circle" />
          </TCITooltip.Trigger>
          <TCITooltip.Content>{tooltipMessage}</TCITooltip.Content>
        </TCITooltip>
      </h4>
    );
  }

  componentDidMount() {
    $(document).on('ajax:complete', function(xhr) {
      const { num_of_questions } = JSON.parse(xhr.detail[0].responseText);
      this.setState({sharable: num_of_questions > 0})
    }.bind(this));
  }

  _shareQuestionContent() {
    if (this.state.shared && this.props.replaceOnShare) return this._sharedText();
    // AIDEV-NOTE: When withTooltip is false (e.g. inside a dropdown menuitem),
    // skip the share-state tooltips so the parent can wrap the menuitem with
    // its own tooltip — Radix Tooltip on the inner button never sees focus
    // events from arrow-key roving-focus on the menuitem.
    if (this.props.shared) return this.props.withTooltip ? this._sharedTooltip() : this._shareButton();
    if (this.state.sharable) return this._shareButton();

    return this.props.withTooltip ? this._unsharableTooltip() : this._shareButton();
  }

  render() {
    return (
      <div className={styles.shareQuestionContainer}>
        {this._shareQuestionTooltip()}
        <div>
          {this._shareQuestionContent()}

          <Modal
            closeModal={this._closeModal.bind(this)}
            isOpen={this.state.modalIsOpen}
            headerText={`Share ${this.props.model}`}
          >
            <Form
              onSuccess={this._onSuccess.bind(this)}
              closeModal={this._closeModal.bind(this)}
              {...this.props}
            />
          </Modal>
        </div>
      </div>
    );
  }
}
